import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import {
  INSUFF_DATA_FAILED,
  INSUFF_DATA_LOADING,
  INSUFF_DATA_SUCCESS,
  INSUFF_DATA_SAVE_FAILED,
  INSUFF_DATA_SAVE_LOADING,
  INSUFF_DATA_SAVE_SUCCESS,
  INSUFF_UPLOAD_FILE_MULTIPART_FAILED,
  INSUFF_UPLOAD_FILE_MULTIPART_LOADING,
  INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS,
  REMOVE_SINGLE_FILE_FAILED,
  REMOVE_SINGLE_FILE_LOADING,
  REMOVE_SINGLE_FILE_SUCCESS,
  INSUFF_DELETE_FILES_FAILED,
  INSUFF_DELETE_FILES_LOADING,
  INSUFF_DELETE_FILES_SUCCESS,
} from "../Constants/InsuffConstants";
import { handleApiError } from "../Helper/actionHelper";

const errorMsg = "Something went wrong. Please try again.";

export const getInsuffData = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: INSUFF_DATA_LOADING });
    const requestData = {
      token: userLocalData.id,
      // group: 4,
      // referenceNo: "1234567890",
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/getInsuffData",
      requestData,
      {
        headers: headers,
      }
    );
    console.log('INSUFF_DATA....', data)

    dispatch({
      type: INSUFF_DATA_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: INSUFF_DATA_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const saveInsuffData = (record) => async (dispatch) => {
  let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));

  const requestData = {
    token:
      userLocalData.id,
    ...record
  };

  try {
    dispatch({ type: INSUFF_DATA_SAVE_LOADING });
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    const { data: result } = await axios.post(FOLDERPATH +
      "/CandidateApi/saveInsuffData",
      requestData,
      {
        headers: headers,
      }
    );
    if (result.status === "success") {

      const { data } = result;

      dispatch({
        type: INSUFF_DATA_SAVE_SUCCESS,
        payload: data,
      });


      const msg = "Saved Successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      dispatch(getInsuffData());
    }
    // handleApiError(result); 

  } catch (error) {
    dispatch({
      type: INSUFF_DATA_SAVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const uploadFileViaMultipartInsuff =
  (insuffId, files, record = null) =>
    async (dispatch) => {
      console.log("file in action", files)
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const demoFormaData = {
        random_folder: 'insuff',
        row_num: insuffId,
        token: userLocalData.id,
        files
      }
      console.log("demoData...",demoFormaData)
      let formData = new FormData();
      Object.keys(demoFormaData).map((k) => {
        formData.set(k, demoFormaData[k])
      })
      for (let i = 0; i < files.length; i++) {
        formData.append(`${'files'}[${i}]`, files[i]);
      }

      try {
        dispatch({ type: INSUFF_UPLOAD_FILE_MULTIPART_LOADING });
        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };

        const { data } = await axios.post(
          FOLDERPATH +
          "/CandidateApi/uploadInsuffDocs",
          formData,
          {
            headers,
          }
        );
        if (data.status === "success") {
          dispatch({
            type: INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS,
            payload: data,
          });
          console.log('succes data..', data)
          const msg = "Saved Successfully";
          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }

        handleApiError(data);
      } catch (error) {
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: INSUFF_UPLOAD_FILE_MULTIPART_FAILED,
          payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,
        });

        handleApiError(error);
      }
    };

export const removeInsuffFile =
  (fileName, record = null) =>
    async (dispatch) => {
      try {
        dispatch({ type: REMOVE_SINGLE_FILE_LOADING });

        let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

        const requestData = {
          token: userLocalData.id,
          ...record,
        };

        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };

        const { data } = await axios.post(
          FOLDERPATH + "/CandidateApi/deleteInsuffDoc",
          requestData,
          {
            headers,
          }
        );
        if (data?.status === 'success') {
          data.fileName = fileName;

          dispatch({
            type: REMOVE_SINGLE_FILE_SUCCESS,
            payload: data,
          });
          const msg = "Removed Successfully";

          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        handleApiError(data);
      } catch (error) {
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: REMOVE_SINGLE_FILE_FAILED,
          payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,
        });
        handleApiError(error);
      }
    };


export const removeDocFolderInsuff =
  (record = null) =>
    async (dispatch) => {
      try {
        dispatch({ type: INSUFF_DELETE_FILES_LOADING });

        let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

        const requestData = {
          token: userLocalData.id,
          ...record,
        };

        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };

        const { data } = await axios.post(
          FOLDERPATH + "/CandidateApi/deleteInsuffDocBulk",
          requestData,
          {
            headers,
          }
        );
        if (data?.status === 'success') {

          dispatch({
            type: INSUFF_DELETE_FILES_SUCCESS,
            payload: data,
          });
          const msg = "Removed Successfully";

          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        handleApiError(data);
      } catch (error) {
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: INSUFF_DELETE_FILES_FAILED,
          payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,
        });
        handleApiError(error);
      }
    };